import React, { useState, Fragment } from 'react';
import {
    CardText,
    CardSubtitle,
    Card,
    CardBody,
    CardImg,
    Button,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_RoomDelete_ById } from '../../../../../../constants/APIs';
import {
    faShower,
    faBed,
    faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropertyForm from './PropertyForm';
import PropertyImage from './PropertyImage';

export default function PropertyCard({ property, LoadData, propertyTags }) {    
    const {
        name,
        type,
        bedrooms,
        baths,
        guests,
        description,
        propertyImages,
        tagList,
    } = property
        ;
    const defaultImage = 'https://via.placeholder.com/300/';
    const [visible, setVisible] = useState(false);
    const [visibleImage, setVisibleImage] = useState(false);

    const handleDelete = roomId => {
        const data = { id: roomId, deleter: 'Test' };
        AxiosAPI({
            method: 'delete',
            url: `${gAPI_RoomDelete_ById}/${roomId}`,
            data: data,
        })
            .then(res => {
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            })
            .catch(err => {
                console.log('err', err);
            });
    };

    const getPropertyData = () => {
        setVisible(!visible);
    };

    return (
        <Fragment>
            <Card className="mb-4">
                <div className="position-relative">
                    {propertyImages.length > 0 && (
                        <CardImg top src={propertyImages[0].url} alt="Card image cap" />
                    )}
                    {propertyImages.length === 0 && (
                        <CardImg top src={defaultImage} alt="Card image cap" />
                    )}
                </div>
                <CardBody>
                    <CardSubtitle className="mb-4">{name} </CardSubtitle>
                    {type === "HolidayHome" && (
                        <Fragment>
                            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                                <CardText className="mb-2 font-weight-light">
                                    <FontAwesomeIcon icon={faBed} /> {bedrooms} Bedrooms
                                </CardText>
                                <CardText className="mb-2 mr-5 font-weight-light">
                                    <FontAwesomeIcon icon={faShower} /> {baths} Baths
                                </CardText>
                                <CardText className="mb-2 font-weight-light">
                                    <FontAwesomeIcon icon={faUser} />  {guests} Guests
                                </CardText>
                            </div>
                        </Fragment>
                    )}

                    <Button
                        style={{ margin: '2px' }}
                        color="primary"
                        outline
                        size="sm"
                        onClick={() => { getPropertyData(); }}
                    >
                        Edit
                    </Button>
                    <Button
                        color="secondary"
                        size="sm"
                        style={{ margin: '2px' }}
                        outline
                        onClick={() => {
                            setVisibleImage(!visibleImage);
                        }}
                    >
                        + Add Images
                    </Button>
                </CardBody>
            </Card>
            {visible === true ? (
                <PropertyForm
                    propertyId={property.id}
                    visible={visible}
                    propertyTags={propertyTags}
                    toggle={() => {
                        setVisible(!visible);
                    }}
                    LoadData={LoadData}
                />
            ) : null}
            <PropertyImage
                images={property.propertyImages}
                visible={visibleImage}
                propertyId={property.id}
                toggle={() => {
                    setVisibleImage(!visibleImage);
                }}
            />
        </Fragment>
    );
}